import { render } from "./ModalSameAddress.vue?vue&type=template&id=f94a3302&scoped=true"
import script from "./ModalSameAddress.vue?vue&type=script&lang=js"
export * from "./ModalSameAddress.vue?vue&type=script&lang=js"

import "./ModalSameAddress.vue?vue&type=style&index=0&id=f94a3302&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94a3302"]])

export default __exports__